class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');

    const searchModal = this.querySelector('.search-modal');
    const searchContent = this.querySelector('.search-modal__content');

    if (searchContent) {
      ['click', 'touchstart', 'touchend', 'pointerdown', 'pointerup'].forEach((evtName) => {
        searchContent.addEventListener(evtName, (event) => {
          event.stopPropagation();
        });
      });
    }

    if (searchModal) {
      ['click', 'touchstart', 'touchend', 'pointerdown', 'pointerup'].forEach((evtName) => {
        searchModal.addEventListener(evtName, (event) => {
          if (!event.target.closest('.search-modal__content')) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            if (evtName === 'click' || evtName === 'touchend') {
              this.close(false);
            }
          }
        }, { passive: false });
      });
    }
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    // Clicks inside this modal's own content panel (search, password, …) must pass
    // through untouched, otherwise form inputs and submit buttons stop working.
    const content = this.detailsContainer.querySelector('[tabindex="-1"]');
    const isInsideContent =
      (content && content.contains(event.target)) ||
      event.target.closest('.search-modal__content') ||
      event.target.closest('summary');
    if (!isInsideContent) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.close(false);
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    setTimeout(() => {
      document.body.addEventListener('click', this.onBodyClickEvent, { passive: false });
      document.body.addEventListener('touchend', this.onBodyClickEvent, { passive: false });
    }, 50);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.removeEventListener('touchend', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
